import { createMutation } from '@tanstack/svelte-query';
import { subscribeToNewsletterRecaptcha } from '../subscribeToNewsletterRecaptcha/subscribeToNewsletterRecaptcha';

export const createNewsletterRecaptchaMutation = () => {
	return createMutation(() => ({ mutationFn: subscribeToNewsletterRecaptcha }));
};
